import {Component, Input, ViewChild} from "@angular/core";
import {StandardName} from "../../../../store/state/order.state";
import {NbPopoverDirective, NbPosition} from "@nebular/theme";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {FormGroup} from "@angular/forms";
import {CompanyGeneralInfoFormService} from "../form-service/company-general-info.form.service";
import {Observable} from "rxjs";

@Component({
    selector: 'employees-input',
    templateUrl: './employees-input.template.html',
    styleUrls: ['../company-general-info.style.scss', './employees-input.style.scss'],
    standalone: false
})
export class EmployeesInputComponent {

	@Input() idPrefix: string;
	@Input() label: string;
	@Input() standard: StandardName;
	@Input() isClientInput: boolean;
	@Input() form: FormGroup;
	@Input() controlName: string;
	@Input() connectedEmployeesControl: string;
	@Input() popoverPlacement: NbPosition | string = NbPosition.RIGHT;

	@ViewChild(NbPopoverDirective, {static: false}) popover: NbPopoverDirective;

	constructor(public formService: CompanyGeneralInfoFormService) {
	}

	preventNonNumericalInput(e) {
		const pattern = /[0-9]/;
		const inputChar = String.fromCharCode(e.charCode);

		if (!pattern.test(inputChar)) {
			event.preventDefault();
		}
	}

	preventMoreThanExpectedInput() {
		const employeeInputControl = this.formService.getFormControl(this.standard, this.controlName);
		if (employeeInputControl && employeeInputControl.value > CompanyGeneralInfoFormService.MAX_NUMBER_OF_EMPLOYEES) {
			this.formService.getFormControl(this.standard, this.controlName).setValue(CompanyGeneralInfoFormService.MAX_NUMBER_OF_EMPLOYEES);
		}
	}

	hidePopover() {
		this.popover.hide();
	}

	showPopover() {
		const employeeInputControl = this.formService.getFormControl(this.standard, this.controlName);
		if (employeeInputControl) {
			this.showPopoverIfNeeded(employeeInputControl.value);
		}
	}

	showPopoverIfNeeded(event: Event | string) {
		if (event) {
			const employeeCount: number = +event;
			if (employeeCount > CompanyGeneralInfoFormService.MAX_NUMBER_OF_EMPLOYEES) {
				this.popover.show();
			} else {
				this.popover.hide();
			}
		}
	}

	getFormKey(): string {
		return this.standard;
	}

	getFormService(): FormService {
		return this.formService;
	}

	anyEmployeeControlInvalid(): boolean {
		const anyInvalid = this.formService.isInvalid(this.standard, this.controlName) || this.formService.isInvalid(this.standard, this.connectedEmployeesControl);
		anyInvalid && !!this.formService.getFormControl(this.standard, this.connectedEmployeesControl) && this.formService.triggerValidationsFor(this.standard, this.connectedEmployeesControl);
		return anyInvalid;
	}

	fullControlName(controlPrefix: string) {
		return controlPrefix + this.standard;
	}

	isInvalid(controlPrefix: string) {
		return this.formService.isInvalid(this.standard, controlPrefix);
	}

	getValidationErrors(controlPrefix: string): Observable<string> {
		return this.formService.getErrorsString(this.getFormKey(), controlPrefix);
	}
}
